import { css } from "../styled-system/css";
import { CustomOrderContainer } from "./features/customOrder";
import { Error } from "./features/error/Error";
import { useProduct } from "./hooks/useProduct";
import { isValidUrl } from "./utils/url";

function App() {
  const { isLoading, error } = useProduct();

  if (isLoading) {
    return null;
  }

  if (error?.status === 404 || !isValidUrl()) {
    return (
      <div
        className={css({
          bg: "black.100",
          width: "100%",
          minHeight: "100vh",
          pb: "calc(134px + 112px)",
        })}
      >
        <Error />
      </div>
    );
  }

  return (
    <>
      <CustomOrderContainer />
    </>
  );
}

export default App;
